const SET_APP_LOADER = 'SET_APP_LOADER';
export default {
    SET_APP_LOADER
}